module.exports = __webpack_public_path__ + "img/材料力学6_9_3.6ec86ca6.jpg";